/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formposition_Others1Inputs */

const ja_contact_formposition_others1 = /** @type {(inputs: Contact_Formposition_Others1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

const en_contact_formposition_others1 = /** @type {(inputs: Contact_Formposition_Others1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Others`)
};

/**
* | output |
* | --- |
* | "Others" |
*
* @param {Contact_Formposition_Others1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formposition_others1 = /** @type {((inputs?: Contact_Formposition_Others1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formposition_Others1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formposition_others1(inputs)
	return en_contact_formposition_others1(inputs)
});
export { contact_formposition_others1 as "contact_formPosition_others" }